import type { CellContext } from '@tanstack/react-table'

import { type Project, ProjectStatusBadge } from '@/modules/projects'

export const StatusCell = (cell: CellContext<Project, string>) => (
  <ProjectStatusBadge status={cell.getValue()} />
)
